module.exports = __webpack_public_path__ + "img/logo-hy-b2c-square.f7a593b.svg";